export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) ||
  (typeof window !== 'undefined' ? window.location.origin : '');

export const buildCanonicalUrl = (path: string): string =>
  `${SITE_URL}${path === '/' ? '/' : path}`;

export const ARTICLE_HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Cozy%20minimal%20desk%20with%20notebook%20coffee%20and%20tablet%20editorial%20blog%20workspace%20soft%20morning%20light%20warm%20neutral%20tones&width=1600&height=600&seq=article-hero-bg&orientation=landscape&nocache=true';